import styled from 'styled-components';
interface IContainer {
  isDark: Boolean;
}
const Container = styled.div`
  padding: 20px;

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px ${(props: IContainer) => (props.isDark ? '#121212' : '#fff')} inset !important;
    box-shadow: 0 0 0px 1000px ${(props: IContainer) => (props.isDark ? '#121212' : '#fff')} inset !important;
  }
`;

const LatenessContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0px 10px 0px;
  flex-wrap: wrap;
`;

const Form = styled.form`
  display: flex;
  width: 100%;
  margin-top: 20px;
`;

export { Container, Form, LatenessContainer };
